module.exports = __webpack_public_path__ + "static/img/8.75913b3e.png";